import router from './router'
import store from './store'
import { Toast } from 'vant'
import { getToken } from '@/utils/auth' // get token from cookie
import { pathMatcher } from '@/utils/index'

const whiteList = ['/login', '/registry', '/', '/index', '/category', '/detail/**', '/diamondGoodsList/**', '/search/**', '/order/coupon', '/agreement', '/download'] // 白名单
let openApp = 0
router.beforeEach(async(to, from, next) => {
  // 设置标题
  document.title = to.meta.title || 'mall'

  if ((from.path === '/user' || to.path !== '/user') &&
    (from.path === '/login' || to.path !== '/login') &&
    (from.path === '/mush' || to.path !== '/mush')) {
    if (openApp > 0) {
      window.setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('androidShowTop', 'gray', (data) => {
          // console.log(JSON.parse(data))
        })
      })
    } else {
      openApp++
    }
  } else {
    window.setupWebViewJavascriptBridge(bridge => {
      bridge.callHandler('androidShowTop', 'green', (data) => {
        // console.log(JSON.parse(data))
      })
    })
  }

  // 根据token判断用户是否登录
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // 如果已经登录了，而去的又是login页就重定向到首页
      next({ path: '/' })
    } else {
      const hasUserInfo = store.getters.id
      if (hasUserInfo) {
        next()
      } else {
        // 如果用户刷新了浏览器，那么需要重新请求基本信息塞到vuex中进行状态管理
        try {
          await store.dispatch('user/getInfo')
          next()
        } catch (error) {
          if (pathMatcher(whiteList, to.path)) {
            next()
          } else {
            // 清空token重新去登录
            // await store.dispatch('user/resetToken')
            // next(`/login?redirect=${encodeURIComponent(location.href)}`)
          }
        }
      }
    }
  } else {
    if (pathMatcher(whiteList, to.path)) {
      console.log(to.path)
      next()
    } else {
      // 如果当前页面不是登录页，才进行重定向
      if (to.path !== '/login') {
        next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
      } else {
        next()
      }
    }
  }
})

router.afterEach(() => {
  Toast.clear()
})
